<footer class="welcome-planner-view__footer">
  <ci-button
    class="welcome-planner-view__button ci-btn-primary-s-filled"
    type="button"
    (click)="handleGoToPlannerClick()"
  >
    {{ 'Ir al planificador' | translate }}
  </ci-button>
</footer>